import React from 'react';
import PropTypes from 'prop-types';
import Button from '../../common/Fields/Button';
import { formatAmount, getStateCodeOptions } from 'helpers/utilities';
import moment from 'moment';
require('react-datetime/css/react-datetime.css');

class AddManualProperty extends React.Component {
  static propTypes = {
    saveManualMLSProperty: PropTypes.func.isRequired,
    opportunityPayload: PropTypes.object.isRequired,
    onClickCancel: PropTypes.func.isRequired
  };

  state = {
    listingContractDate: '',
    expirationDate: '',
    listingPrice: '',
    address1: '',
    city: '',
    propState: '',
    zip: '',
    fieldsValidationError: '',
    mlsId: ''
  };

  updateListingDate = date => {
    const updatedState = {};
    updatedState['listingContractDate'] = date ? moment(date).format('YYYY-MM-DD') : date;
    this.setState(updatedState);
  };

  updateExpirationDate = date => {
    const updatedState = {};
    updatedState['expirationDate'] = date ? moment(date).format('YYYY-MM-DD') : date;
    this.setState(updatedState);
  };

  updatePropInfo = e => {
    const fieldName = e.target.name;
    const value = e.target.value;
    const updatedState = {};

    switch (fieldName) {
      case 'mlsListingPrice':
        updatedState['listingPrice'] = formatAmount(value);
        break;
      case 'addPropState':
        updatedState['propState'] = value;
        break;
      case 'addPropAdd1':
        updatedState['address1'] = value;
        break;
      case 'addPropAdd2':
        updatedState['address2'] = value;
        break;
      case 'addPropCity':
        updatedState['city'] = value;
        break;
      case 'addPropZip':
        updatedState['zip'] = value;
        break;
      case 'addPropMlsId':
        updatedState['mlsId'] = value;
        break;
      default:
        break;
    }

    this.setState(updatedState);
  };

  saveManualProperty = async () => {
    const property = {
      mlsListingId: this.state.mlsId,
      price: this.state.listingPrice,
      listingDate: this.state.listingContractDate,
      listingExpirationDate: this.state.expirationDate,
      address: {
        addressType: 'Property',
        address1: this.state.address1,
        city: this.state.city,
        stateOrProvince: this.state.propState,
        postalCode: this.state.zip
      }
    };
    const propertyAddress = property.address;
    if (
      propertyAddress.address1 &&
      propertyAddress.city &&
      propertyAddress.stateOrProvince &&
      propertyAddress.postalCode &&
      property.price &&
      this.isDateValid(property.listingDate) &&
      this.isDateValid(property.listingExpirationDate)
    ) {
      const propObj = {
        property: {
          ...property,
          propertyRoles: ['Opportunity'],
          propertyInfoSource: 'Manual'
        }
      };
      const response = await this.props.saveManualMLSProperty(
        this.props.opportunityPayload,
        propObj
      );
      response && this.props.onClickCancel();
    } else {
      const addressFieldError = [];
      const dateFieldError = [];
      if (!property.price) {
        addressFieldError.push('Price');
      }
      if (!propertyAddress.address1) {
        addressFieldError.push('Address');
      }
      if (!propertyAddress.City) {
        addressFieldError.push('City');
      }
      if (!propertyAddress.stateOrProvince) {
        addressFieldError.push('State');
      }
      if (!propertyAddress.postalCode) {
        addressFieldError.push('Zip');
      }
      if (!property.mlsListingId) {
        addressFieldError.push('MlsId');
      }
      if (!this.isDateValid(property.listingDate)) {
        dateFieldError.push('List Date');
      }
      if (!this.isDateValid(property.listingExpirationDate)) {
        dateFieldError.push('Exp. Date');
      }
      let addressErrorMessage = '';
      if (addressFieldError.length > 0) {
        addressErrorMessage = '<div>' + addressFieldError.join(', ');
        if (addressFieldError.length === 1) {
          addressErrorMessage += ' is';
        } else {
          addressErrorMessage += ' are';
        }
        addressErrorMessage += ' mandatory field(s). </div>';
      }
      if (dateFieldError.length > 0) {
        addressErrorMessage += '<div>' + dateFieldError.join(', ');
        if (dateFieldError.length === 1) {
          addressErrorMessage += ' is';
        } else {
          addressErrorMessage += ' are';
        }
        addressErrorMessage += ' invalid. </div>';
      }
      this.setState({ fieldsValidationError: addressErrorMessage });
    }
  };

  isDateValid = date => {
    const sqlMin = moment('1/1/1753', 'MM/DD/YYYY');
    const d = moment(date);
    const isEmpty = !date || date.length === 0;
    if (isEmpty || d < sqlMin) {
      return false;
    } else {
      return true;
    }
  };

  render () {
    return (
      <React.Fragment>
        {this.state.fieldsValidationError ? (
          <div
            className='error-message'
            dangerouslySetInnerHTML={{
              __html: this.state.fieldsValidationError
            }}
          />
        ) : null}
        <div className='information-container'>
          <div className='row'>
            <div className='col-6'>
              <label>List Date</label>
              <input type='date' value={this.state.listingContractDate} onChange={ev => this.updateListingDate(ev.target.value)}
                className='form-control no-border underline-bottom'placeholder='mm/dd/yyyy' />
            </div>
            <div className='col-6'>
              <label>List Price</label>
              <input
                type='text'
                className='form-control no-border underline-bottom'
                name='mlsListingPrice'
                value={formatAmount(this.state.listingPrice, false, true)}
                onBlur={this.formatDollarAmount}
                onChange={this.updatePropInfo}
                maxLength='30'
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-6'>
              <label>Exp. Date</label>
              <input type='date' value={this.state.expirationDate} onChange={ev => this.updateExpirationDate(ev.target.value)}
                className='form-control no-border underline-bottom' placeholder='mm/dd/yyyy' />
            </div>
            <div className='col-6'>
              <label>MLS-ID</label>
              <input
                type='text'
                value={this.state.mlsId}
                className='form-control no-border underline-bottom'
                name='addPropMlsId'
                id='addPropMlsId'
                maxLength='50'
                onChange={this.updatePropInfo}
              />
            </div>
          </div>
          <div className='row'>
            <div className='col-12'>
              <label>Address</label>
              <input
                type='text'
                value={this.state.address1}
                className='form-control no-border underline-bottom margin-bottom-15'
                name='addPropAdd1'
                id='addPropAdd1'
                maxLength='100'
                onChange={this.updatePropInfo}
              />
            </div>
          </div>

          <div className='row'>
            <div className='col-4'>
              <label>City</label>
              <input
                type='text'
                value={this.state.city}
                className='form-control no-border underline-bottom'
                name='addPropCity'
                id='addPropCity'
                maxLength='50'
                onChange={this.updatePropInfo}
              />
            </div>
            <div className='col-4'>
              <label>State</label>
              <select
                className='form-control'
                name={'addPropState'}
                value={this.state.propState}
                onChange={this.updatePropInfo}
                style={{ borderBottom: '1px solid rgba(0, 0, 0, 0.15)' }}
              >
                {getStateCodeOptions().map((option, index) => (
                  <option key={index} value={option.value}>
                    {option.text}
                  </option>
                ))}
              </select>
            </div>
            <div className='col-4'>
              <label>Zip Code</label>
              <input
                type='text'
                value={this.state.zip}
                className='form-control no-border underline-bottom'
                name='addPropZip'
                id='addPropZip'
                maxLength='10'
                onChange={this.updatePropInfo}
              />
            </div>
          </div>
        </div>
        <div className='property-footer white-background'>
          <div className='col-6'>
            <Button
              classVal='form-control cancel-btn'
              onClickHandler={() => this.props.onClickCancel()}
              name={'Cancel'}
            />
          </div>

          <div className='col-6'>
            <Button
              classVal='form-control save-btn'
              onClickHandler={this.saveManualProperty}
              name={'Save'}
            />
          </div>
        </div>
      </React.Fragment>
    );
  }
}

export default AddManualProperty;
